import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numbersSuffixes',
})
export class NumbersSuffixesPipe implements PipeTransform {
  transform(input: number, minCharacters?: number, decimals?: number): string {
    const suffixes = ['k', 'M', 'B', 'T', 'P', 'E'];
    if (isNaN(minCharacters)) {
      minCharacters = 4;
    }

    if (isNaN(decimals)) {
      decimals = 2;
    }

    if (isNaN(input)) {
      return '';
    }

    if (input.toFixed().length < minCharacters) {
      return this.roundDown(input, decimals).toLocaleString('en-US', {
        maximumFractionDigits: decimals,
      });
    }

    const exp = Math.floor(Math.log(input) / Math.log(1000));

    return (
      this.roundDown(input / Math.pow(1000, exp), decimals).toLocaleString(
        'en-US',
        {
          maximumFractionDigits: decimals,
        }
      ) + suffixes[exp - 1]
    );
  }

  roundDown(value: number, decimals: number): number {
    return Math.floor(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/pipes/numbers-suffixes.pipe.ts